import React from "react";
import { Container } from "./styled";

const TasksSection = ({ body }) => (
    <Container>
        {body}
    </Container>
);

export default TasksSection;